
/**
 *  Debugging / Development Helper
 *
 *  Removes duplicate stylesheets as soon as
 *  the dom has loaded, this also means that
 *  no stylesheet will even attempt to load.
 */


document.addEventListener(
    'DOMContentLoaded',
    deduplicateStylesheets
)


const { debug } = console

function deduplicateStylesheets (){


    const stylesheets = document
        .querySelectorAll(`[ rel = stylesheet ]`)


    const urls = new Set

    let externalCount = 0

    stylesheets.forEach(( stylesheet ) => {

        const { href } = stylesheet

        if( urls.has(href) ){
            stylesheet.remove()
            externalCount++
        }

        urls.add(href)
    })


    const tags = document
        .querySelectorAll(`style`)

    const ids = new Set

    let internalCount = 0

    tags.forEach(( tag ) => {

        const { id } = tag.dataset

        if( ! id )
            return

        if( ids.has(id) ){
            internalCount++
            tag.remove()
        }

        ids.add(id)
    })

    debug(
        `Removed ( ${ externalCount } ) external + ( ${
        internalCount } ) internal duplicate stylesheets.` )
}
